const authTypes = {
  SETTING_USER: 'SIGNING_IN_USER',
  USER_SET: 'USER_SIGNED_IN',
  ERROR_SETTING_USER: 'RECEIVED_USER',
}

export default authTypes
